<s1-input-select [control]="control" [itemsList]="tipiAllegato" [label]="'tipoAllegato.nuovo.title'" [readonly]="readonly"></s1-input-select>